// eslint-disable-next-line import/prefer-default-export
export const LOAD_HISTORIETYPEN = 'load_historietypen';
